// @i18n-ignore-file
import { CONFIG_AUTH_ENDPOINT } from '@src/config/env'

export default function getBaseAmplifyConfig() {
  return {
    authenticationFlowType: 'USER_PASSWORD_AUTH',
    oauth: {
      domain: CONFIG_AUTH_ENDPOINT,
      scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: `${location.origin}/log-in`,
      redirectSignOut: location.origin,
      responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_AND_IDENTITY_POOLS',
    aws_cognito_username_attributes: ['EMAIL'],
    aws_cognito_social_providers: ['GOOGLE'],
    aws_cognito_signup_attributes: ['EMAIL'],
    aws_cognito_mfa_configuration: 'OFF',
    aws_cognito_mfa_types: ['SMS'],
    aws_cognito_password_protection_settings: {
      passwordPolicyMinLength: 8,
      passwordPolicyCharacters: [],
    },
    aws_cognito_verification_mechanisms: ['EMAIL'],
    // stores token in cookie instead of local storage
    ssr: true,
  }
}
